import { SearchOutlined } from "@ant-design/icons";
import type { ButtonHTMLAttributes, DetailedHTMLProps } from "react";

type AddonSearchButtonProps = DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

// A simple button with a search icon to be used as an input addon.
export const AddonSearchButton = ({ className, type = "button", ...buttonProps }: AddonSearchButtonProps) => (
    <button type={type} className={[className, "vyne-input-addon-button"].filter(Boolean).join(" ")} {...buttonProps}>
        <SearchOutlined />
    </button>
);
